var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpercutAvatar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2899_12341)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 45,
    height: 45,
    rx: 22.5,
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.26667,
    y: 3.26667,
    width: 44.4667,
    height: 44.4667,
    rx: 22.2333,
    stroke: "white",
    strokeWidth: 0.533334
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2899_12341)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.0426 27.1822C21.4912 27.5032 18.7855 30.5041 18.8326 34.0697V34.2505C18.8326 34.9408 19.3923 35.5005 20.0826 35.5005C20.773 35.5005 21.3326 34.9408 21.3326 34.2505V34.0197C21.2951 31.8304 22.9107 29.9635 25.0826 29.6863C27.3753 29.459 29.4183 31.1333 29.6456 33.426C29.659 33.5615 29.6658 33.6976 29.666 33.8338V34.2505C29.666 34.9408 30.2256 35.5005 30.916 35.5005C31.6063 35.5005 32.166 34.9408 32.166 34.2505V33.8338C32.1619 30.1477 29.1705 27.1629 25.4844 27.167C25.3371 27.1672 25.1897 27.1722 25.0426 27.1822Z",
    fill: "#CBCBCB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5 25.5C28.2614 25.5 30.5 23.2614 30.5 20.5C30.5 17.7386 28.2614 15.5 25.5 15.5C22.7386 15.5 20.5 17.7386 20.5 20.5C20.5027 23.2603 22.7397 25.4972 25.5 25.5ZM25.5 18C26.8807 18 28 19.1193 28 20.5C28 21.8807 26.8807 23 25.5 23C24.1193 23 23 21.8807 23 20.5C23 19.1193 24.1193 18 25.5 18Z",
    fill: "#CBCBCB"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2899_12341",
    x: 0.866665,
    y: 0.866665,
    width: 53.5333,
    height: 53.5333,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2.13334,
    dy: 2.13334
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.13334
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2899_12341"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2899_12341",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2899_12341"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(15.5 15.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpercutAvatar);
export default __webpack_public_path__ + "static/media/upercut-avatar.c486a5254de46fa7c9d9a27ebf41f0b3.svg";
export { ForwardRef as ReactComponent };